import { createPageApp } from '@/lib/createPageApp'
import LoginPage from './LoginPage.vue'

createPageApp(LoginPage).mount()
